import * as React from 'react';
import { Form, Text, Select, Checkbox } from 'react-form';
import { SingleDatePicker } from 'react-dates';
import { api } from '@src/services/api';
import { customer } from '@src/services/user';
import { _ } from "@src/services/i18n";
import { Switch } from '@src/services/form';
import { classNames, css, mixin, vars, defaultProps, formatters } from '@src/services/theme';
import { ProtoEdit, PropsEdit, StateEdit } from '@src/components/Proto';
import { Box, Modal } from '@src/components';

// typing
interface LocalProps extends PropsEdit {
}
interface LocalState extends StateEdit {
    focused: any;
}

// style
const style = css`
    form {
        ${mixin.form}
    }
`;

// component
export class Dealer extends ProtoEdit<LocalProps, LocalState> {
    
	// render
	render() {
        const loading = this.loading();
        if (loading) return null;
        const { id, onCancel } = this.props;
        const { data, values = {}, entity = null, error } = this.state;
        if (entity === null) return null;

        const brands = data.brands.map(v => ({ value: v.id, label: v.name }));

        return (
            <Modal
                title={!id ? _('new_title', 'SettingsDealer') : _('edit_title', 'SettingsDealer', { name: entity.description } ) }
                open={true}
                onClose={() => { if (onCancel) onCancel() } }
            >
                <div className={style}>
                    <Form
                        onSubmit={(v) => this.save({...v})}
                        defaultValues={entity}
                    >
                    {formApi => (
                        <form
                            onSubmit={formApi.submitForm}
                        >
                            <div className="fields">
                                <article>
                                    <label htmlFor="brand">{_('field_brand', 'SettingsDealer')}</label>
                                    <Select field="brand" id="brand" options={brands} className="form-control" />
                                </article>
                                <article>
                                    <label htmlFor="customer">{_('field_customer', 'SettingsDealer')}</label>
                                    <Text field="customer" id="customer" className="form-control" />
                                </article>
                                <article>
                                    <label htmlFor="description">{_('field_description', 'SettingsDealer')}</label>
                                    <Text field="description" id="description" className="form-control" />
                                </article>
                                <article>
                                    <label htmlFor="email">{_('field_email', 'SettingsDealer')}</label>
                                    <Text field="email" id="email" className="form-control" />
                                </article>
                            </div>
                            {error && this.outputError()}
                            <footer>
                                <button type="button" className="btn btn-cancel" onClick={() => { if (onCancel) onCancel() } }>
                                {_(`btn_cancel`, 'Settings')}
                                </button>
                                <button type="submit" className="btn btn-primary">
                                {_(`btn_save`, 'Settings')} 
                                </button>
                            </footer>
                        </form>
                    )}
                    </Form>
                </div>
            </Modal>
		);
	}
}


// WEBPACK FOOTER //
// ./src/components/Settings/Dealer.tsx